import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { doc, updateDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { db } from '../../../core/services/firebase';

export function MemoDialog({ certificate, open, onClose, onSaved }) {
  const [memo, setMemo] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (certificate) {
      setMemo(certificate.memorandum || '');
      setError(null);
    }
  }, [certificate]);

  const handleSave = async () => {
    if (!certificate) return;
    setSaving(true);
    setError(null);
    try {
      await updateDoc(doc(db, 'certificates', certificate.id), {
        memorandum: memo,
      });
      onSaved(certificate.id, memo);
      onClose();
    } catch (err) {
      console.error('Failed to save memo:', err);
      setError('保存に失敗しました');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>メモ</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          minRows={4}
          value={memo}
          onChange={(e) => setMemo(e.target.value)}
          disabled={saving}
          error={!!error}
          helperText={error}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          キャンセル
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={saving}>
          {saving ? <CircularProgress size={20} /> : '保存'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
